import React, { useMemo } from 'react';
import InventoryMetaPage from '../components/inventory/InventoryMetaPage';

export default function BrandsPage() {
    const columns = useMemo(() => [
        { key: 'name', label: 'Brand' },
        { key: 'slug', label: 'Slug' },
        { key: 'usage_count', label: 'Products' },
        { key: 'created_at', label: 'Created Date', render: (row) => new Date(row.created_at).toLocaleDateString() },
        { key: 'status', label: 'Status' },
    ], []);

    return (
        <InventoryMetaPage
            title="Brands"
            type="brand"
            columns={columns}
            fields={[
                { name: 'name', label: 'Brand Name' },
                { name: 'slug', label: 'Slug', placeholder: 'Auto from name if empty' },
                { name: 'description', label: 'Description', type: 'textarea' },
            ]}
            buildPayload={(form) => ({
                name: form.name,
                slug: form.slug,
                description: form.description,
                status: form.status,
            })}
        />
    );
}
